export enum CellRendererType {
  VIDEO = 'VIDEO',
  IMAGE = 'IMAGE',
}

export const VIDEO_RECT_NAME = 'videoRect';
